//@flow
//@flow
import { Formik } from 'formik';
import _ from 'lodash';
import 'moment/locale/pt-br';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { alertActions } from '../../_actions/alert.action';
import { objectsConstants, objectsEnuns } from '../../_constants/objects.constants';
import { formatterHelper } from '../../_helpers/formatter.helper';
import { dateHelper } from '../../_helpers/date.helper';
import { translate } from '../../_helpers/messages.helper';
import { cooperativaService } from '../../_services/cooperativa.service';
import { defaultService } from '../../_services/defaultService';
import { estabelecimentoFinanceiroService } from '../../_services/estabelecimentoFinanceiro.service';
import { midiaService } from '../../_services/midia.service';
import ApiIBGE from '../../_services/uf.service';
import { whatsappService } from '../../_services/whatsapp.service';
import { FormGroup } from '../../components/FormGroup';
import { HorarioFuncionamento } from '../../components/HorarioFuncionamento/HorarioFuncionamento';
import CheckBoxInputOnly from '../../components/inputs/CheckBoxInputOnly';
import CpfCnpjInput from '../../components/inputs/CpfCnpjInput';
import FormInput from '../../components/inputs/FormInput';
import FormSelectInput from '../../components/inputs/FormSelectInput';
import ImageInput from '../../components/inputs/ImageInput';
import InputViewEdit from '../../components/inputs/InputViewEdit';
import SelectInput from '../../components/inputs/SelectInput';
import ZipCodeInput from '../../components/inputs/ZipCodeInput';
import { ModalWhatsapp } from '../../components/Modal/ModalWhatsapp';
import MultiTelefones from '../../components/MultiTelefones/MultiTelefones';
import imagemBG from '../../images/bgImage.jpeg';
import DatePickerInput from '../../components/inputs/DatePickerInput';


type Props = {
  match: any,
  nome?: string,
  callbackOnSave?: any,
};

type State = {

};

const EstabelecimentoFinanceiroValidate = Yup.object().shape({
  nome: Yup.string()
    .min(3, 'Nome muito curto!')
    .max(60, 'Nome muito grande!')
    .required('Obrigatório'),
  email: Yup.string().nullable().notRequired().email('Email inválido'),
  cpfCnpj: Yup.string().required('Obrigatório'),

});

class EstabelecimentoFinanceiroForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {

    };
  }


  goToViewEntity = (values) => {
    this.props.history.push({
      pathname: '/estabelecimentoFinanceiro/view/' + values.id,
      state: { entity: values },
    });
  };

  resetForm = (initialValues) => {
    this.formRef.resetForm(initialValues);
  };



  saveForm = () => {
    let _this = this;

    let values = _this.formRef.state.values;



    // TODO corrigir data de proximo pagament

    let promise = new Promise(function (resolve) {
      _this.formRef.validateForm(values).then((error) => {
        if (_.isEmpty(error)) {

          _this.props.loading(true);
          estabelecimentoFinanceiroService.doSave(values).then(
            (response) => {
              _this.props.success({
                message: `Estabelecimento, foi ${!values.id ? 'criado' : 'alterado'
                  } com sucesso!`,
              });
              let id = values.id
                ? values.id
                : defaultService.getIdFromUrl(response.headers.location);
              values.id = id;
              _this.props.loading(false);
              _this.goToViewEntity(values);
              resolve(true);
            },
            (erros) => {
              _this.props.loading(false);
              _this.props.error({
                message: 'Não foi possível salvar estabelecimentoFinanceiro.',
              });
              try {
                let response = erros.response.data;
                if (response && response.messages) {
                  for (var i = 0; i < response.messages.length; i++) {
                    let erroItem = response.messages[i];
                    _this.formRef.setFieldError(
                      erroItem.fieldName,
                      translate(erroItem.message.code)
                    );
                  }
                }
              } catch (error) {
                console.log(error);
              }
              console.log(error);
            }
          );
        } else {
          console.log(error);
          // if (_.get(error, 'telefones')) {
          //   alertActions.error('Preencha ao menos um telefone de contato');
          // } else {
          //   alertActions.error('Campos obrigatórios não preenchidos');
          // }
          resolve(false);
        }
      });
    });
    return promise;
  };

  logoUrl = (values) => {
    if (values.foto && values.foto.id) {
      return midiaService.url(values.foto.id);
    } else {
      if (values.foto) {
        return values.foto.midiaConteudoVO.foto64;
      } else {
        return imagemBG;
      }
    }
  };




  render() {
    let _this = this;
    const { viewMode } = this.props;


    console.log(this.props.entity);
    return (
      <React.Fragment>
        <Formik
          enableReinitialize
          validationSchema={EstabelecimentoFinanceiroValidate}
          initialValues={this.props.entity}
          validateOnBlur={false}
          validateOnChange={false}
          ref={(form) => {
            this.formRef = form;
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            validationSchema,
            validateForm,
            setValues,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="form-inside">
                <div className="row section-form">
                  <div className="col-12 col-md-1">
                    <ImageInput
                      maxWidth={120}
                      maxHeight={120}
                      height={120}
                      required={true}
                      erroMensagem={values.foto}
                      onChange={(imageVO) => setFieldValue('foto', imageVO)}
                      dataUrl={this.logoUrl(values)}
                      viewMode={true}
                    />


                  </div>

                  <div className="col-12 col-md-11 form-row">
                    <FormGroup className="col-12 col-md-6 col-lg-5">
                      <InputViewEdit
                        component={FormInput}
                        label={'Nome'}
                        type="text"
                        id="nome"
                        name="nome"
                        placeholder="Digite o nome do estabelecimento"
                        value={values.nome}
                        onChange={(name, value) => setFieldValue(name, value)}
                        noSize={true}
                        erroMensagem={errors.nome}
                        viewMode={true}
                        required={true}
                        viewClassName={'font-weight-bold'}
                      />
                    </FormGroup>
                    <FormGroup className="col-12 col-md-6 col-lg-2">
                      <InputViewEdit
                        component={CpfCnpjInput}
                        label={'CPF ou CNPJ'}
                        type="text"
                        id="cpfCnpj"
                        name="cpfCnpj"
                        placeholder="Digite o CPF ou CNPJ"
                        value={values.cpfCnpj}
                        onChange={(name, value) => setFieldValue(name, value)}
                        noSize={true}
                        erroMensagem={errors.cpfCnpj}
                        viewMode={true}
                        required={true}
                        viewClassName={'font-weight-bold'}
                      />
                    </FormGroup>
                    <FormGroup className="col-12 col-md-6 col-lg-3">
                      <InputViewEdit
                        component={FormInput}
                        label={'E-mail principal'}
                        type="email"
                        id="email"
                        name="email"
                        placeholder="Digite o e-mail principal"
                        value={values.email}
                        onChange={(name, value) => setFieldValue(name, value)}
                        noSize={true}
                        required={true}
                        viewMode={true}
                        erroMensagem={errors.email}
                      />
                    </FormGroup>

                    <FormGroup className="col-12 col-lg-3">
                      <InputViewEdit
                        component={SelectInput}
                        id={'bloqueadoFencom'}
                        options={[
                          { label: 'Sim', value: true },
                          { label: 'Não', value: false },
                        ]}
                        returnFullObject={true}
                        label="Bloqueio Fencom?"
                        required={true}
                        labelKey={'label'}
                        valueKey={'value'}
                        viewMode={viewMode}
                        name={'bloqueadoFencom'}
                        defaultValue={
                          values.bloqueadoFencom &&
                            values.bloqueadoFencom.value === false
                            ? 'Não'
                            : formatterHelper.getLabelEnum(
                              values.bloqueadoFencom && values.bloqueadoFencom.value
                                ? values.bloqueadoFencom.value
                                : values.bloqueadoFencom,
                              objectsConstants.SIM_NAO
                            )
                        }
                        value={
                          _.isBoolean(values.bloqueadoFencom)
                            ? formatterHelper.getEnum(
                              values.bloqueadoFencom,
                              objectsConstants.SIM_NAO
                            )
                            : values.bloqueadoFencom
                        }
                        onChange={(name, value) => {
                          setFieldValue(name, value.value);
                        }}
                      />
                    </FormGroup>

                    <FormGroup className="col-12 col-lg-2">
                      <InputViewEdit
                        component={SelectInput}
                        options={objectsEnuns.STATUS}
                        label="Status"
                        id="status"
                        name="status"
                        viewMode={viewMode}
                        valueKey="name"
                        labelKey="description"
                        returnFullObject={true} // isso é ESSENCIAL
                        value={_.get(values, 'status')}
                        placeholder="Status do estabelecimento"
                        defaultValue={_.get(values, 'status.description')}
                        onChange={(name, value) => {
                          setFieldValue(name, value);
                        }}
                      />
                    </FormGroup>

                    <FormGroup className="col-12 col-lg-2">
                      <InputViewEdit
                        component={DatePickerInput}
                        label="Data do próximo pagamento"
                        name="dataProximoPagamento"
                        id="dataProximoPagamento"
                        value={values.dataProximoPagamento}
                        onChange={(name, value) => {
                          setFieldValue(name, value);
                        }}
                        viewMode={viewMode}
                        placeholder={'--/--/----'}
                        defaultValue={
                          _.get(values, `dataProximoPagamento`)
                            ? dateHelper.format(_.get(values, `dataProximoPagamento`), {
                              mode: 'DATE',
                            })
                            : '--'
                        }
                      />
                    </FormGroup>
                    <FormGroup className="col-12 col-lg-2">
                      <InputViewEdit
                        component={FormInput}
                        label="Número de licenças"
                        type="number"
                        name="quantidadeProfissionais"
                        id="quantidadeProfissionais"
                        placeholder="Número de profissionais"
                        viewMode={viewMode}
                        required={true}
                        value={_.get(values, 'quantidadeProfissionais')}
                        onChange={(name, value) => {
                          setFieldValue(name, value);
                        }}
                      />
                    </FormGroup>
                  </div>

                </div>
              </div>


              <h2 className="w-100">Endereço</h2>
              <div className="form-inside">
                <div className="row section-form">
                  <FormGroup className="col-12 col-md-3">
                    <InputViewEdit
                      component={ZipCodeInput}
                      label="CEP"
                      id="enderecoId"
                      name="endereco.id"
                      value={_.get(values, 'endereco.cep')}
                      erroMensagem={errors.endereco && errors.endereco.cep}
                      required={true}
                      placeholder="CEP"
                      required={true}
                      onChange={(name, value) => {
                        if (values.endereco) {
                          value.id = values.endereco.id;
                        }

                        value.estado = value.uf;
                        setFieldValue('endereco', value);
                      }}
                      returnFullCity={false}
                      viewMode={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-md-7">
                    <InputViewEdit
                      component={FormInput}
                      label={'Logradouro'}
                      placeholder="Digite o logradouro"
                      onChange={(name, value) => setFieldValue(name, value)}
                      noSize={true}
                      erroMensagem={errors.logradouro}
                      viewMode={true}
                      required={true}
                      id="enderecoLogradouro"
                      value={_.get(values, 'endereco.logradouro')}
                      name="endereco.logradouro"
                      erroMensagem={_.get(errors, 'endereco.logradouro')}
                    />
                  </FormGroup>
                  <FormGroup className="col-3 col-md-2">
                    <InputViewEdit
                      component={FormInput}
                      type="text"
                      label="Nº"
                      placeholder="Nº"
                      onChange={setFieldValue}
                      noSize={true}
                      viewMode={true}
                      id="endereconumero"
                      value={_.get(values, 'endereco.numero')}
                      name="endereco.numero"
                      erroMensagem={_.get(errors, 'endereco.numero')}
                      required={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-9 col-md-3">
                    <InputViewEdit
                      component={FormInput}
                      label="Complemento"
                      type="text"
                      placeholder="Complemento"
                      erroMensagem={errors.complemento}
                      onChange={setFieldValue}
                      noSize={true}
                      viewMode={true}
                      id="enderecocomplemento"
                      value={_.get(values, 'endereco.complemento')}
                      name="endereco.complemento"
                      erroMensagem={_.get(errors, 'endereco.complemento')}
                    />
                  </FormGroup>
                  <FormGroup className="col-12 col-md-3">
                    <InputViewEdit
                      component={FormInput}
                      label="Bairro"
                      type="text"
                      placeholder="Bairro"
                      erroMensagem={errors.bairro}
                      onChange={setFieldValue}
                      noSize={true}
                      viewMode={true}
                      id="enderecobairro"
                      value={_.get(values, 'endereco.bairro')}
                      name="endereco.bairro"
                      erroMensagem={_.get(errors, 'endereco.bairro')}
                      required={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-8 col-md-4">
                    <InputViewEdit
                      component={FormInput}
                      label="Cidade"
                      type="text"
                      placeholder="Cidade"
                      erroMensagem={errors.cidade}
                      onChange={setFieldValue}
                      noSize={true}
                      viewMode={true}
                      id="enderecocidade"
                      value={_.get(values, 'endereco.cidade')}
                      name="endereco.cidade"
                      erroMensagem={_.get(errors, 'endereco.cidade')}
                      required={true}
                    />
                  </FormGroup>
                  <FormGroup className="col-4 col-md-2">
                    <InputViewEdit
                      component={FormSelectInput}
                      label={'UF'}
                      id="uf"
                      name="endereco.estado"
                      placeholder="UF"
                      value={_.get(values, 'endereco.estado')}
                      onChange={setFieldValue}
                      noSize={true}
                      erroMensagem={_.get(errors, 'endereco.estado')}
                      viewMode={true}
                      required={true}
                      returnFullObject={false}
                      valueKey={'sigla'}
                      labelKey={'sigla'}
                      multi={false}
                      service={ApiIBGE.findAllEstados}
                      sortKey={'sigla'}
                    />
                  </FormGroup>
                </div>
              </div>



              <h2 className="w-100">Telefones</h2>
              <div className="form-inside">
                {/* <div className="row section-form"> */}
                {values.telefones &&
                  values.telefones.map((telefone, index) => {
                    return (
                      <div className="row section-form" key={index}>
                        <MultiTelefones
                          entity={values}
                          index={index}
                          viewMode={true}
                          size={values.telefones.length}
                          handleChange={handleChange}
                          errors={errors}
                          propName={`telefones[${index}]`}
                          onChange={setFieldValue}
                          size={values.telefones.length}
                          removeItem={() => {
                            this.removeItemInArray(
                              `telefones`,
                              index,
                              values,
                              setValues
                            );
                          }}
                        ></MultiTelefones>
                      </div>
                    );
                  })}
              </div>
            </form>
          )}
        </Formik>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(mapStateToProps, mapDispatch, null, {
  forwardRef: true,
})(EstabelecimentoFinanceiroForm);
